import { X } from "lucide-react";

import { formatBoliviaDateTime } from "@/lib/dateTime";

const labels = {
  actor_id: "ID del responsable",
  actor_name: "Responsable",
  actor_role: "Rol",
  after: "Resultado registrado",
  before: "Valor anterior",
  client: "Cliente",
  created_at: "Creado el",
  created_by: "Creado por",
  created_by_name: "Nombre del creador",
  descuento: "Descuento",
  edit_history: "Historial de revisiones",
  event_type: "Tipo de evento",
  fecha_vencimiento: "Vencimiento",
  id: "Identificador",
  inicial: "Inicial",
  inicial_porcentaje: "Inicial (%)",
  lot: "Lote",
  meses: "Plazo (meses)",
  observaciones: "Observaciones",
  plan_pagos: "Plan de pagos",
  precio_m2: "Precio por m²",
  precio_total: "Precio total",
  reglas_aplicadas: "Reglas aplicadas",
  resource_id: "ID del recurso",
  resource_type: "Recurso",
  saldo: "Saldo",
  source: "Origen",
  status: "Estado",
  superficie: "Superficie",
  updated_at: "Actualizado el",
  updated_by: "Actualizado por",
  valor_cuota: "Valor de cuota",
  vendedor: "Asesor",
};

function labelFor(key) {
  if (labels[key]) return labels[key];
  return key.replaceAll("_", " ").replace(/^./, (letter) => letter.toUpperCase());
}

function displayValue(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Sí" : "No";
  return String(value);
}

function structuredValue(value) {
  if (!value || typeof value !== "object") return displayValue(value);
  return JSON.stringify(
    value,
    (key, nestedValue) => (
      key.endsWith("_at") && typeof nestedValue === "string" && nestedValue.includes("T")
        ? formatBoliviaDateTime(nestedValue)
        : nestedValue
    ),
    2,
  );
}

export default function AuditDetailDrawer({ detail, onClose, title }) {
  return (
    <div className="audit-drawer-overlay" data-testid="audit-detail-drawer">
      <aside
        aria-label="Detalle auditado"
        aria-modal="true"
        className="audit-detail-drawer"
        role="dialog"
      >
        <div className="audit-drawer-header">
          <div>
            <span className="eyebrow">REGISTRO AUDITADO</span>
            <h2>{title}</h2>
          </div>
          <button
            aria-label="Cerrar detalle auditado"
            className="icon-button"
            data-testid="close-audit-detail-button"
            onClick={onClose}
            type="button"
          >
            <X size={19} />
          </button>
        </div>
        <div className="audit-drawer-content" data-testid="audit-detail-content">
          <dl className="audit-detail-fields">
            {Object.entries(detail).map(([key, value]) => (
              <div key={key}>
                <dt>{labelFor(key)}</dt>
                <dd className={value && typeof value === "object" ? "structured-value" : ""}>
                  {key.endsWith("_at") && typeof value === "string"
                    ? formatBoliviaDateTime(value)
                    : structuredValue(value)}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </aside>
    </div>
  );
}